import { GridColDef } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import ChipsCell from '@/shared/components/Table/components/ChipsCell/ChipsCell'
import { EditableTextCell } from '@/shared/components/Table/components/EditableCell/EditableCell'
import styles from '../../MenuMangementColumns.module.scss'
import { currencySymbol } from '@/shared/utils/price'

export const useDishPriceBySizeColumnsConfigInDetailsFrom = () => {
  const { t } = useTranslation()

  const columns: (GridColDef & {
    // Unit rendered inside EditableTextCell
    endAdornment?: string
  })[] = [
    {
      field: 'id',
      headerName: 'ID',
      resizable: false,
      width: 44,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      hideable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'dishSizes',
      headerName: t('TABLE.MENU.HEADERS.DISH_SIZES'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => {
        const chipPayload =
          typeof params.value === 'string'
            ? params.value.split(',').map((label, index) => ({
                id: index,
                label: label.trim()
              }))
            : []

        return <ChipsCell chipPayload={chipPayload} />
      }
    },
    {
      field: 'priceBySize',
      headerName: t('TABLE.MENU.HEADERS.PRICE_BY_SIZE'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,
      type: 'string',
      endAdornment: currencySymbol(),
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: EditableTextCell
    }
  ]
  return columns as GridColDef[]
}
